import { PointsAccountingException } from '@/domain/points/accounting/exception/PointsAccountingException'

export class CouldNotGetTransactionException extends PointsAccountingException {

}

